var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHashtagOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7804 3.19397C11.8885 2.65347 11.5378 2.12767 10.997 2.01957C10.4563 1.91147 9.93021 2.262 9.82206 2.8025L8.78203 8H6C5.44772 8 5 8.44772 5 9C5 9.55228 5.44772 10 6 10H8.38183L7.58143 14H4.5C3.94772 14 3.5 14.4477 3.5 15C3.5 15.5523 3.94772 16 4.5 16H7.18123L6.21954 20.806C6.11138 21.3465 6.46209 21.8723 7.00286 21.9804C7.54363 22.0885 8.06969 21.738 8.17785 21.1975L9.21787 16H13.1812L12.2195 20.806C12.1114 21.3465 12.4621 21.8723 13.0029 21.9804C13.5436 22.0885 14.0697 21.738 14.1778 21.1975L15.2179 16H18C18.5523 16 19 15.5523 19 15C19 14.4477 18.5523 14 18 14H15.6181L16.4185 10H19.5C20.0523 10 20.5 9.55228 20.5 9C20.5 8.44772 20.0523 8 19.5 8H16.8187L17.7804 3.19397C17.8885 2.65347 17.5378 2.12767 16.997 2.01957C16.4563 1.91147 15.9302 2.262 15.8221 2.8025L14.782 8H10.8187L11.7804 3.19397ZM14.3818 10H10.4185L9.61807 14H13.5814L14.3818 10Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtagOutline);
export default __webpack_public_path__ + "static/media/hashtag_outline.09a7e2ca99fb507c9a9adec8cc14cbb6.svg";
export { ForwardRef as ReactComponent };